
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR
// GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR


const GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR= createAsyncThunk(
  "getAllBlogSectionsBySectionNameBasedOnCreator/getAllBlogSectionsBySectionNameBasedOnCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllBlogSectionsBySectionNameBasedOnCreatorSlice = createSlice({
  name: "getAllBlogSectionsBySectionNameBasedOnCreatorSlice",
  initialState: {
    getAllBlogSectionsBySectionNameBasedOnCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllBlogSectionsBySectionNameBasedOnCreator: (state) => {
        state.getAllBlogSectionsBySectionNameBasedOnCreator.loading = false
        state.getAllBlogSectionsBySectionNameBasedOnCreator.error = false
        state.getAllBlogSectionsBySectionNameBasedOnCreator.data = []
        state.getAllBlogSectionsBySectionNameBasedOnCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR.fulfilled, (state, action) => {
      state.getAllBlogSectionsBySectionNameBasedOnCreator = {
        ...state.getAllBlogSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR.pending, (state, action) => {
      state.getAllBlogSectionsBySectionNameBasedOnCreator = {
        ...state.getAllBlogSectionsBySectionNameBasedOnCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR.rejected, (state, action) => {
      state.getAllBlogSectionsBySectionNameBasedOnCreator = {
        ...state.getAllBlogSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllBlogSectionsBySectionNameBasedOnCreatorAction = {
    GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR,
};

export { getAllBlogSectionsBySectionNameBasedOnCreatorAction };
export default getAllBlogSectionsBySectionNameBasedOnCreatorSlice.reducer;
export const {setInitialStateOfgetAllBlogSectionsBySectionNameBasedOnCreator} = getAllBlogSectionsBySectionNameBasedOnCreatorSlice.actions
